export const PAGE_LIMIT = 10;
export const INC = "INC";
export const DEC = "DEC";
export const CRD = "CardPay";
export const COD = "CashOnDelivery";
export const BACKEND_URI ="http://localhost:5000";
